var _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9989 22.2615H21C21 17 13.9982 15.9432 13.9982 15.9432L12 18L10 15.9432C10 15.9432 2.9989 16.5 2.9989 22.2615Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5C8.79628 11.0249 9.74818 10.6769 10.7937 10.5M16 11.5C15.2037 11.0249 14.2518 10.6769 13.2063 10.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 5,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.375 5.5H7.625C8.06338 3.52727 8.43345 1.5 11.0315 1.5H12.9685C15.5666 1.5 15.9366 3.52727 16.375 5.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.5H7.625M7.625 5.5H16.375M7.625 5.5C8.06338 3.52727 8.43345 1.5 11.0315 1.5H12.9685C15.5666 1.5 15.9366 3.52727 16.375 5.5M16.375 5.5H19",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployer);
export default __webpack_public_path__ + "static/media/employer.6d3320155e8ac89748514fe936de85ac.svg";
export { ForwardRef as ReactComponent };